/**
 * PATH: packages/job-hub/src/jobs/qa/useQaCapabilities.ts
 * FILE_ID: JOBHUB-QA-CAPABILITIES-001
 * PURPOSE: Live can_build and can_create_qa_job for one job.
 * LANDMINE: Loading and error both close Build and job create. Run stays open.
 */
import { useQuery } from '@tanstack/react-query'
import { useJobHubDataAdapter } from '../jobHubDataAdapter'

export function qaCapabilitiesQueryKey(jobId?: number | null) {
  return ['qa-capabilities', jobId ?? null] as const
}

export function qaCapabilityFlags(
  data: unknown,
  status: 'pending' | 'error' | 'success',
): { canBuild: boolean; canCreateQaJob: boolean } {
  if (status !== 'success' || data == null || typeof data !== 'object' || Array.isArray(data)) {
    return { canBuild: false, canCreateQaJob: false }
  }
  const row = data as { can_build?: unknown; can_create_qa_job?: unknown }
  return {
    canBuild: row.can_build === true,
    canCreateQaJob: row.can_create_qa_job === true,
  }
}

export function useQaCapabilities(jobId?: number | null) {
  const { client } = useJobHubDataAdapter()
  const query = useQuery({
    queryKey: qaCapabilitiesQueryKey(jobId),
    queryFn: async () => {
      const response = await client.get('/api/qa/capabilities/', {
        params: jobId != null ? { job_id: jobId } : undefined,
      })
      return response.data
    },
  })
  const status = query.isError ? 'error' : query.isSuccess ? 'success' : 'pending'
  return { ...qaCapabilityFlags(query.data, status), isLoading: status === 'pending' }
}
